export class UsuarioLogadoModel {
  public idEmpresa: string;
  public nome: string;
  public token: string;
  constructor() {}
}
